export const config = {
    baseUrl: "https://api.mediawan.com/",
    apiBase: "api/v1"
};